import SaveButtonComponent from '@/components/save-button/save-button.vue';
import DualButtonComponent from '@/components/dual-button/dual-button.vue';
import ActionButtonsComponent from '@/components/action-buttons/action-buttons.vue';
import DeleteModalComponent from '@/components/delete-modal/delete-modal.vue';

import InputTextComponent from '@/components/input-text/input-text.vue';
import InputSelectOneComponent from '@/components/input-select-one/input-select-one.vue';
import InputImageComponent from '@/components/input-image/input-image.vue';
import InputSelectManyComponent from '@/components/input-select-many/input-select-many.vue';
import TablePageableComponent from '@/components/table-pageable/table-pageable.vue';

export function initCustomComponents(vue) {
  vue.component('c-save-button', SaveButtonComponent);
  vue.component('c-dual-button', DualButtonComponent);
  vue.component('c-action-buttons', ActionButtonsComponent);
  vue.component('c-delete-modal', DeleteModalComponent);
  vue.component('input-text', InputTextComponent);
  vue.component('input-select-one', InputSelectOneComponent);
  vue.component('input-image', InputImageComponent);
  vue.component('input-select-many', InputSelectManyComponent);
  vue.component('table-pageable', TablePageableComponent);
}
